import { stages } from './stages';

export const publicPath = '/';

const AUTH_ROUTES = {
  SIGNIN: `${publicPath}login`,
  SIGNUP: `${publicPath}signup`,
  SIGNUP_STEP_TWO: `${publicPath}signup/password`,
  ACCOUNT_VALIDATION: `${publicPath}signup/validation`,
  EMAIL_VALIDATION: `${publicPath}email-validation`,
  RECOVER: `${publicPath}login/recover`,
  VERIFYREGISTERCODE: `${publicPath}signup/verifyRegisterCode`,
  FORGOT: `${publicPath}login/forgot`,
  RESETPASSWORD: `${publicPath}login/reset`,
  ADD_PHONE: `${publicPath}phone`,
  PARTNER_SIGNIN: `${publicPath}partner-login`,
  AUTH_ONBOARDING: `${publicPath}onboarding`,
};

const CHECKOUT_ROUTES = {
  CHECKOUT_PRODUCTS: `${publicPath}checkout/products`,
  CART: `${publicPath}checkout/cart`,
  CHECKOUT_SEARCH_STEP: `${publicPath}checkout/search`,
  CHECKOUT_CONSULTANT_STEP: `${publicPath}checkout/consultant`,
  CHECKOUT_SUCCESS_STEP: `${publicPath}checkout/success`,

  CHECKOUTFIRSTSTEP: `${publicPath}checkout/init`,
  CHECKOUTPLANSSTEP: `${publicPath}validation/upselling`,
  QUESTIONNARIREUPSELLINGSTEP: `${publicPath}questionnaire/upselling`,
  CHECKOUTCONSULTANTREVIEWSTEP: `${publicPath}checkout/consultant/review`,
  CHECKOUT_UPSELLING: `${publicPath}result/upselling`,
  PAYMENT_LATER: `${publicPath}result/pay-later`,
  RESULT_FILTER: `${publicPath}result/filter`,
  RESULT_EFIRMA: `${publicPath}result/efirma`,
  PAYMENT_LATER_XML: `${publicPath}xml/result/pay-later`,
  FLEX_LITE: `${publicPath}result/flex-lite`,
  PREVIOUS_YEARS_INFO: `${publicPath}previous-years/info`,
  PREVIOUS_YEARS_FILTER: `${publicPath}previous-years/filter`,
  PREVIOUS_YEARS_EFIRMA: `${publicPath}previous-years/efirma`,
  PREVIOUS_YEARS_PROVIDER_ACCOUNT: `${publicPath}previous-years/pay-later-account`,
  PREVIOUS_YEARS_CALCULATE_RESULT: `${publicPath}previous-years/calculate-result`,
  PREVIOUS_YEARS: `${publicPath}previous-years/result`,
  PREVIOUS_YEARS_WORKING: `${publicPath}previous-years/in-progress`,
  PREVIOUS_YEARS_PRESALE: `${publicPath}previous-years/presale`,
  PREVIOUS_YEARS_EFIRMA_TYPE_FORM: `${publicPath}previous-years/efirma/form`,
  PREVIOUS_YEARS_CALCULATING_LOADER: `${publicPath}previous-years/loader`,
  PREVIOUS_YEARS_DIFFERENCE: `${publicPath}previous-years/difference`,
  PREVIOUS_YEARS_CHECKOUT: `${publicPath}previous-years/checkout`,
};

const DG_QUIZ = {
  DATAGATHERING_QUIZ: `${publicPath}datagathering/quiz`,
  DATAGATHERING_QUIZ_FIRST_QUESTION: `${publicPath}datagathering/quiz/question/first`,
  DATAGATHERING_QUIZ_SECOND_QUESTION: `${publicPath}datagathering/quiz/question/second`,
  DATAGATHERING_QUIZ_THIRD_QUESTION: `${publicPath}datagathering/quiz/question/third`,
  DATAGATHERING_QUIZ_FOUR_QUESTION: `${publicPath}datagathering/quiz/question/four`,
  DATAGATHERING_QUIZ_FIVE_QUESTION: `${publicPath}datagathering/quiz/question/five`,
  DATAGATHERING_QUIZ_SIX_QUESTION: `${publicPath}datagathering/quiz/question/six`,
  DATAGATHERING_QUIZ_RESULT: `${publicPath}datagathering/quiz/result`,
};

const DATAGATHERING_ROUTES = {
  DATAGATHERING_TIPS_LOADER: `${publicPath}datagathering/onboarding`,
  DATAGATHERING_LOADER: `${publicPath}datagathering/loader`,
  DATAGATHERING_LOADER_XML: `${publicPath}datagathering/xml/loader`,
  DATAGATHERING_ERROR: `${publicPath}datagathering/retry`,
  // LEGACY
  DATAGATHERING_IDENTIFICATION: `${publicPath}datagathering`,
  DATAGATHERING_INFO: `${publicPath}datagathering/info`,
  DATAGATHERING_REQUEST_PHONE: `${publicPath}datagathering/request-phone`,
  DATAGATHERING_IDENTIFICATION_RFC: `${publicPath}datagathering/access`,
  DATAGATHERING_IDENTIFICATION_EFIRMA: `${publicPath}datagathering/access/efirma`,
  DATAGATHERING_HELP: `${publicPath}datagathering/help`,
  DATAGATHERING_UPDATE_CREDENTIALS: `${publicPath}datagathering/update`,
  DATAGATHERING_LOADER_STEP: `${publicPath}datagathering/loaderStep`,
  DATAGATHERING_FIRST_STEP: `${publicPath}datagathering/first-step`,
  DATAGATHERING_CALCULATE_RFC: `${publicPath}datagathering/calculate-rfc`,
  DATAGATHERINGFILTER1: `${publicPath}validation/filter/first`,
  DATAGATHERINGFILTER2: `${publicPath}validation/filter/second`,
  DATAGATHERINGSALARY: `${publicPath}validation/salary`,
  DATAGATHERINGINTEREST: `${publicPath}validation/interest`,
  DATAGATHERINGDIVIDENS: `${publicPath}validation/dividens`,
  DATAGATHERINGLEASE: `${publicPath}validation/lease`,
  DATAGATHERINGFEE: `${publicPath}validation/fee`,
  DATAGATHERINGTECH: `${publicPath}validation/tech`,
  DATAGATHERINGDEDUCTIONS: `${publicPath}validation/deductions`,
  DATAGATHERINGINVOICES: `${publicPath}validation/invoices`,
  DATAGATHERINGEXIT: `${publicPath}validation/exit`,
  DATAGATHERINGFORM: `${publicPath}validation/form`,
  SIMULATIONFORM: `${publicPath}datagathering/simulation`,
  DATAGATHERING_PRESENTATION: `${publicPath}datagathering/presentation`,
  DATAGATHERING_PROFILE: `${publicPath}datagathering/profile`,
  DATAGATHERING_EFIRMA_APPLICATION: `${publicPath}datagathering/e-firma-request`,
  DATAGATHERING_REFERRAL: `${publicPath}datagathering/referral`,
  DATAGATHERING_SAT_ERROR: `${publicPath}datagathering/time-limit`,
  DATAGATHERING_ESTIMATED_RESULT: `${publicPath}datagathering/estimated`,
  DATAGATHERING_TYPEFORM_ESTIMATED_RESULT: `${publicPath}datagathering/typeform-result`,
  DATAGATHERING_PRESENTATION_XML: `${publicPath}datagathering/xml/presentation`,
  DATAGATHERING_PROFILE_XML: `${publicPath}datagathering/xml/profile`,
  DATAGATHERING_EFIRMA_APPLICATION_XML: `${publicPath}datagathering/xml/e-firma-request`,
  DATAGATHERING_REFERRAL_XML: `${publicPath}datagathering/xml/referral`,
  DATAGATHERING_SAT_ERROR_XML: `${publicPath}datagathering/xml/time-limit`,
  DATAGATHERING_ESTIMATED_RESULT_XML: `${publicPath}datagathering/xml/estimated`,
  DATAGATHERING_TYPEFORM_ESTIMATED_RESULT_XML: `${publicPath}datagathering/xml/typeform-result`,
  ...DG_QUIZ,
};

const PARTNERS_ROUTES = {
  SIGNUP_SKANDIA: `${publicPath}signup/skandia`,
  SIGNUP_GAIA: `${publicPath}signup/gaia`,
  SIGNUP_PARTNERSHIPSMX: `${publicPath}signup/partnershipsmx`,
};

const USER_ROUTES = {
  HOME: `${publicPath}home`,
  ACCOUNT: `${publicPath}account`,
  ACCOUNT_RFC: `${publicPath}account/rfc`,
  ACCOUNT_EFIRMA: `${publicPath}account/efirma`,
  ACCOUNT_DELETE_INFO: `${publicPath}account/delete/info`,
  ACCOUNT_DELETE_FORM: `${publicPath}account/delete/form`,
  ACCOUNT_SUBSCRIPTION: `${publicPath}account/subscription`,
  VALIDATIONS: `${publicPath}validations`,
};

export const routes = {
  DASHBOARD: publicPath,
  PLANS: `${publicPath}plans`,
  REFERRAL: `${publicPath}referral`,
  RESULT: `${publicPath}result`,
  RESULT_XML: `${publicPath}xml/result`,
  FILING: `${publicPath}filing`,
  FILING_UPSELL: `${publicPath}filing/upsell`,
  FILING_UPSELL_MGM: `${publicPath}filing/upsell-mgm`,
  PRE_FILING: `${publicPath}pre-filing`,
  PRE_FILING_CLABE: `${publicPath}pre-filing/clabe`,
  FILING_XML: `${publicPath}xml/filing`,
  FILING_CLABE_XML: `${publicPath}xml/filing/clabe`,
  FILING_CLABE_FLEX: `${publicPath}flex/filing/clabe`,
  FILING_FLEX: `${publicPath}flex/filing`,
  FILING_INSTANT_REFUND: `${publicPath}flex/instant-refund`,
  FILING_INSTANT_REFUND_ACTIVE: `${publicPath}flex/instant-refund-active`,
  RATING: `${publicPath}rating`,
  PERSONAL_PHONE: `${publicPath}personal-phone`,
  PERSONAL_PHONE_XML: `${publicPath}xml/personal-phone`,
  REQUEST_PHONE: `${publicPath}request-phone`,
  PERSONAL_START: `${publicPath}validations/personal-data-start`,
  JOBS_START: `${publicPath}validations/jobs-start`,
  INVESTMENTS_START: `${publicPath}validations/investments-start`,
  DEDUCTIONS_START: `${publicPath}validations/deductions-start`,
  UPSELLING_PRO: `${publicPath}result/upselling-pro`,
  FIN_SOCIAL_ACCOUNT: `${publicPath}result/pay-later-account`,
  ...DATAGATHERING_ROUTES,
  ...CHECKOUT_ROUTES,
  ...AUTH_ROUTES,
  ...USER_ROUTES,
  ...PARTNERS_ROUTES,
};

export const routesByStage = {
  [stages.DATA_RETRIEVAL]: routes.DATAGATHERING_INFO,
  [stages.DATA_PULLED]: routes.PERSONAL_PHONE,
  [stages.PERSONAL_DATA]: routes.PERSONAL_START,
  [stages.JOBS]: routes.JOBS_START,
  [stages.INVESTMENTS]: routes.INVESTMENTS_START,
  [stages.DEDUCTIONS]: routes.DEDUCTIONS_START,
  [stages.RESULT]: routes.RESULT,
};
